import type { OrganisationAllowance } from "@keydials/api-client";

/** A meter the builder shows: how much of something the plan allows is in use. */
export interface MeterView {
  used: number;
  allowed: number;
  /** 0–1, for the bar. */
  fraction: number;
  full: boolean;
}

export type MeteredThing = "definitions" | "users" | "aiGenerations";

/**
 * The meter to show for one allowance, or null when there is nothing worth showing (KEY-560): the plan isn't governed, the thing
 * isn't counted or capped, or, for designs, the plan includes only one. A single-design plan never shows "0 of 1"; reaching its
 * cap opens the limit sheet instead.
 */
export function meterView(allowance: OrganisationAllowance | null, thing: MeteredThing): MeterView | null {
  if (!allowance?.governed) return null;
  const { used, allowed } = allowance[thing];
  if (used == null || allowed == null) return null;
  if (thing === "definitions" && allowed <= 1) return null;
  return {
    used,
    allowed,
    fraction: allowed <= 0 ? 1 : Math.min(1, used / allowed),
    full: used >= allowed,
  };
}
